import { ABaseModel, MapType } from '@pperform/pp-data-mappers';
import APIError from 'exceptions/APIError';
import {
  fetchCampaignLiveMode,
  fetchCampaignsPreviewMode,
} from 'fetchers/campaign.fetchers';
import type Shipment from 'interfaces/PmParcel';
import { Campaign } from 'models/Campaign.model';

export class CampaignsDTOResponse extends ABaseModel {
  promotionLayout: 'small' | 'medium' | 'large' = 'small';

  @MapType([Campaign])
  campaigns: Campaign[] = [];
}

export const getCampaignsPreviewMode = async (
  orgId: number,
  campaignUuid: string,
): Promise<CampaignsDTOResponse> => {
  try {
    const { data } = await fetchCampaignsPreviewMode(orgId, campaignUuid);

    return CampaignsDTOResponse.fromApiData(data);
  } catch (error) {
    if (error instanceof APIError) {
      return CampaignsDTOResponse.create({});
    }
    throw error;
  }
};

export const getCampaignLiveMode = async (
  orgId: number,
  shipment: Shipment,
  ptpSlug: string,
): Promise<CampaignsDTOResponse> => {
  try {
    const { data } = await fetchCampaignLiveMode(orgId, {
      ptp_slug: ptpSlug,
      shipment: {
        parcel_user_tag: shipment.parcelUserTag,
        line_items: shipment.lineItems?.map((lineItem) => {
          return {
            product_category: lineItem.productCategory,
            product_name: lineItem.productName,
            product_id: lineItem.productId,
          };
        }),
      },
    });
    return CampaignsDTOResponse.fromApiData(data);
  } catch (error) {
    if (error instanceof APIError) {
      return CampaignsDTOResponse.create({});
    }
    throw error;
  }
};
